import { localize } from "@/i18n/translate";
import { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, errorCode } from "@/lib/api";
import { usePortal } from "../i18n";
import { Composer, Thread } from "../Messages";
import { refreshUnread } from "../Shell";
import { TicketHeader } from "./ClientTicket";
import { ErrorNote, Spinner } from "../ui";
const STATUSES = ["neu", "in_bearbeitung", "wartet_auf_kunde", "abgeschlossen"];
export default function AdminTicket() {
  const {
    id
  } = useParams();
  const {
    p,
    errText
  } = usePortal();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const load = useCallback(() => {
    api.get(`/admin/tickets/${id}`).then(r => {
      setData(r.data);
      refreshUnread();
    }).catch(e => setErr(errText(errorCode(e))));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  useEffect(() => {
    load();
  }, [load]);
  const setStatus = async e => {
    setErr(null);
    try {
      await api.patch(`/admin/tickets/${id}`, {
        status: e.target.value
      });
      load();
    } catch (ex) {
      setErr(errText(errorCode(ex)));
    }
  };
  const t = data?.ticket;
  return <div data-testid="admin-ticket-page">
      <Link to="/admin/anfragen" className="mb-8 inline-flex items-center gap-2 text-sm font-medium hover:text-signal" data-testid="admin-ticket-back"><ArrowLeft className="h-4 w-4" aria-hidden="true" /> {localize(p.nav.tickets)}</Link>
      <ErrorNote>{localize(err)}</ErrorNote>
      {localize(!data && !err && <Spinner label={p.loading} />)}
      {localize(t && <>
          <TicketHeader t={t}>
            <div>
              <dt className="eyebrow">{localize(p.adm.clientInfo)}</dt>
              <dd className="mt-1">
                {localize(t.user_name)}{localize(t.user_organisation && ` · ${t.user_organisation}`)}
                <br />
                <a href={`mailto:${t.user_email}`} className="break-all text-mute hover:text-signal">{localize(t.user_email)}</a>
              </dd>
            </div>
          </TicketHeader>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <label htmlFor="ticket-status" className="text-sm font-medium">{localize(p.adm.changeStatus)}</label>
            <select id="ticket-status" value={t.status} onChange={setStatus} className="border border-ink/25 bg-white px-3 py-2 text-sm" data-testid="admin-ticket-status-select">
              {localize(STATUSES.map(s => <option key={s} value={s}>{localize(p.ticket[s])}</option>))}
            </select>
          </div>
          <h2 className="eyebrow mt-10">{localize(p.thread.conversation)}</h2>
          <div className="mt-4"><Thread messages={Array.isArray(data.messages) ? data.messages : []} viewer="admin" /></div>
          <div className="mt-6"><Composer endpoint={`/admin/tickets/${id}/messages`} onSent={load} /></div>
        </>)}
    </div>;
}
